import "swiper/css/bundle";

import "./swipers/experts";
import "./swipers/partners";
import "./swipers/advantages";
import "./swipers/documents";
import "./swipers/dinamic";
